import { render, staticRenderFns } from "./NewInputPeopleNum.vue?vue&type=template&id=70cd8a30&scoped=true"
import script from "./NewInputPeopleNum.vue?vue&type=script&lang=js"
export * from "./NewInputPeopleNum.vue?vue&type=script&lang=js"
import style0 from "./NewInputPeopleNum.vue?vue&type=style&index=0&id=70cd8a30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd8a30",
  null
  
)

export default component.exports